import "../assets/styles/sass/creating-jobs.scss";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const CreatingJobs = () => {
	const [jobTitle, setJobTitle] = useState("");
	const [companyName, setCompanyName] = useState("");
	const [jobDescription, setJobDescription] = useState("");
	const [jobLocation, setJobLocation] = useState("");
	const [salaryRange, setSalaryRange] = useState("");
	const [jobType, setJobType] = useState("");

	const navigate = useNavigate();

	const handleCreateJob = (e) => {
		e.preventDefault();
		if (
			jobTitle === "" ||
			companyName === "" ||
			jobDescription === "" ||
			jobLocation === "" ||
			salaryRange === "" ||
			jobType === ""
		) {
			alert("Please fill all the fields");
		} else {
			axios
				.post("https://job-boarrd.herokuapp.com/createJob", {  
					jobTitle,
					companyName,
					jobDescription,
					jobLocation,
					salaryRange,
					jobType,
				})
				.then((res) => {
					console.log(res.data.job);
					setJobTitle("");
					setCompanyName("");
					setJobDescription("");
					setJobLocation("");
					setSalaryRange("");
					setJobType("");

					console.log(
						jobTitle,
						companyName,
						jobDescription,
						jobLocation,
						salaryRange,
						jobType,
					);

					setTimeout(() => {
						navigate("/careers");
					}, 2000);
				});
		}
	};

	return (
		<div className="create-form-body" title="Create Job Openings">
			<div className="form">
				<form onSubmit={handleCreateJob}>
					<h1> Create New Job Posting </h1>
					<label>Company Name</label>
					<input
						type="text"
						name="companyName"
						value={companyName}
						onChange={(e) => setCompanyName(e.target.value)}
					/>
					<label>Job Title</label>
					<input
						type="text"
						name="jobTitle"
						value={jobTitle}
						onChange={(e) => setJobTitle(e.target.value)}
					/>
					<label>Job Description</label>
					<textarea
						type="text"
						name="jobDescription"
						value={jobDescription}
						onChange={(e) => setJobDescription(e.target.value)}
					/>
					<label>Job Location</label>
					<input
						type="text"
						name="jobLocation"
						value={jobLocation}
						onChange={(e) => setJobLocation(e.target.value)}
					/>
					<label>Job Salary</label>
					<input
						type="text"
						name="salaryRange"
						value={salaryRange}
						onChange={(e) => setSalaryRange(e.target.value)}
					/>
					<label>Job Type</label>
					<input
						type="text"
						name="jobType"
						value={jobType}
						onChange={(e) => setJobType(e.target.value)}
					/>
					<button type="submit">Create Job</button>
				</form>
			</div>
		</div>
	);
};

export default CreatingJobs;
